module.exports = __webpack_public_path__ + "img/logo-sap.0c0e769a.png";